module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('v-row', [_c('v-dialog', {
    attrs: {
      "content-class": "all-dialog-wrapper",
      "persistent": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [(!_vm.isLoading) ? [_c('v-row', {
    staticClass: "close-button"
  }, [_c('v-col', [_c('img', {
    staticClass: "closse-icon-modal",
    attrs: {
      "src": "/static/img/closse.svg"
    },
    on: {
      "click": _vm.closse
    }
  })])], 1), _vm._v(" "), _c('v-form', {
    staticClass: "wrapper-modal"
  }, [_c('v-row', {
    staticClass: "title-text"
  }, [_c('v-col', [_vm._v("\n                АВТОРИЗАЦИЯ \n              ")])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "text-auth"
  }, [_c('v-col', [_vm._v("\n                  Пожалуйста, авторизируйтесь с помощью вашего номера телефона\n                ")])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "input-row"
  }, [_c('v-col', [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('+7(###)-###-##-##'),
      expression: "'+7(###)-###-##-##'"
    }],
    attrs: {
      "color": "grey",
      "placeholder": "+7(###)-###-##-##",
      "label": "Ваш номер телефона",
      "error-messages": _vm.phoneErrors,
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.phone.$touch()
      },
      "blur": function($event) {
        return _vm.$v.phone.$touch()
      }
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  })], 1)], 1), _vm._v(" "), (_vm.isSenden) ? _c('v-row', {
    staticClass: "input-row border-last"
  }, [_c('v-col', [_c('v-text-field', {
    attrs: {
      "color": "grey",
      "error-messages": _vm.codeErrors,
      "counter": 6,
      "required": "",
      "label": "Код из смс"
    },
    on: {
      "input": function($event) {
        return _vm.$v.code.$touch()
      },
      "blur": function($event) {
        return _vm.$v.code.$touch()
      }
    },
    model: {
      value: (_vm.code),
      callback: function($$v) {
        _vm.code = $$v
      },
      expression: "code"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', {
    staticClass: "red-text"
  }, [_c('v-col', [_c('span', {
    class: [_vm.isLoad ? 'timer-gray' : 'timer-red'],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.sendCode
    }
  }, [_vm._v("\n                    Отправить код\n                  ")]), _vm._v(" "), (_vm.isLoad) ? _c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v(_vm._s(_vm.currentTime) + " ")]) : _vm._e()])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "row-button"
  }, [_c('v-col', [_c('ui_btn', {
    attrs: {
      "type": "main-btn full-width"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n                    Войти               \n                  ")])], 1)], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.isLoading) ? [_c('div', {
    staticClass: "wrapper-loading"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "red"
    }
  })], 1)] : _vm._e()], 2)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c5f8766","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/auth/auth.vue
// module id = 365
// module chunks = 2